import { ExperimentConfig, ExperimentDefinition } from './types';

function defineExperiment<const V extends Record<string, string>>(
	exp: ExperimentDefinition<V>
): ExperimentDefinition<V> {
	return exp;
}

// DeepLinks
// ?new_preferred_variant=[EXP_NAME]:[VARIANT_NAME]
// ?new_remove_preferred_experiment=[EXP_NAME]
export const experimentConfig = {
	JW_APP_DOWNLOAD_EXP_1: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
		},
		routes: ['app.detail.movies', 'app.detail.show'],
		tabs: [],
		userTypes: ['LOGGED_OUT'],
		type: 'regular',
	}),
	// ?new_preferred_variant=HACK_SQTV_SR_MX:control
	HACK_SQTV_SR_MX: defineExperiment({
		variants: { CONTROL: 'control' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),
	// ?new_preferred_variant=HACK_SQTV_SR_BR:control
	HACK_SQTV_SR_BR: defineExperiment({
		variants: { CONTROL: 'control' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),
	// ?new_preferred_variant=HACK_SQTV_SR_DE:control
	HACK_SQTV_SR_DE: defineExperiment({
		variants: { CONTROL: 'control' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),
	// ?new_preferred_variant=HACK_SQTV_SR_GB:control
	HACK_SQTV_SR_GB: defineExperiment({
		variants: { CONTROL: 'control' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),
	// ?new_preferred_variant=DOUBLE_STACK_EXP_3:control
	// ?new_preferred_variant=DOUBLE_STACK_EXP_3:variant_1
	// ?new_preferred_variant=DOUBLE_STACK_EXP_3:variant_2
	// ?new_remove_preferred_experiment=DOUBLE_STACK_EXP_3
	DOUBLE_STACK_EXP_3: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'dstack3',
	}),
	// ?new_preferred_variant=ATV_PLACEMENTS_EXP:control
	// ?new_preferred_variant=ATV_PLACEMENTS_EXP:variant_1
	// ?new_preferred_variant=ATV_PLACEMENTS_EXP:variant_2
	// ?new_preferred_variant=ATV_PLACEMENTS_EXP:variant_3
	// ?new_preferred_variant=ATV_PLACEMENTS_EXP:variant_4
	// ?new_preferred_variant=ATV_PLACEMENTS_EXP:variant_5
	// ?new_remove_preferred_experiment=ATV_PLACEMENTS_EXP
	ATV_PLACEMENTS_EXP: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
			VARIANT_5: 'variant_5',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'atvplc',
	}),
	// ?new_preferred_variant=SWIPER_BROWSER_EXP_2:control
	// ?new_preferred_variant=SWIPER_BROWSER_EXP_2:variant_1
	// ?new_preferred_variant=SWIPER_BROWSER_EXP_2:variant_2
	// ?new_preferred_variant=SWIPER_BROWSER_EXP_2:variant_3
	// ?new_remove_preferred_experiment=SWIPER_BROWSER_EXP_2
	SWIPER_BROWSER_EXP_2: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'swibro2',
	}),
	// ?new_preferred_variant=HACK_SQTV_SR_BR_2:control
	HACK_SQTV_SR_BR_2: defineExperiment({
		variants: { CONTROL: 'control' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),
	// ?new_preferred_variant=HACK_SQTV_SR_MX_2:control
	HACK_SQTV_SR_MX_2: defineExperiment({
		variants: { CONTROL: 'control' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),

	// ?new_preferred_variant=EXP_JWTV_PRICING:control
	// ?new_preferred_variant=EXP_JWTV_PRICING:variant_1
	// ?new_preferred_variant=EXP_JWTV_PRICING:variant_2
	// ?new_preferred_variant=EXP_JWTV_PRICING:variant_3
	// ?new_remove_preferred_experiment=EXP_JWTV_PRICING
	EXP_JWTV_PRICING: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),
	// ?new_preferred_variant=EXP_JWTV_AVOD:control
	// ?new_preferred_variant=EXP_JWTV_AVOD:variant_1
	// ?new_preferred_variant=EXP_JWTV_AVOD:variant_2
	// ?new_remove_preferred_experiment=EXP_JWTV_AVOD
	EXP_JWTV_AVOD: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1', VARIANT_2: 'variant_2' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'monetization',
		affiliationShortId: 'jwtavod',
	}),
	// ?new_preferred_variant=EXP_LOWPERF_URL_SWIPER_2:control
	// ?new_preferred_variant=EXP_LOWPERF_URL_SWIPER_2:variant_1
	// ?new_preferred_variant=EXP_LOWPERF_URL_SWIPER_2:variant_2
	// ?new_remove_preferred_experiment=EXP_LOWPERF_URL_SWIPER_2
	EXP_LOWPERF_URL_SWIPER_2: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1', VARIANT_2: 'variant_2' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'loperf2',
	}),

	// ?new_preferred_variant=EXP_JWTV_SR_XMAS_TVOD_TRACKING:control
	EXP_JWTV_SR_XMAS_TVOD_TRACKING: defineExperiment({
		variants: { CONTROL: 'control' },
		routes: [],
		tabs: [],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),
	// ?new_preferred_variant=EXP_JWTV_POPULAR_PAGE:control
	// ?new_preferred_variant=EXP_JWTV_POPULAR_PAGE:variant_1
	// ?new_preferred_variant=EXP_JWTV_POPULAR_PAGE:variant_2
	// ?new_preferred_variant=EXP_JWTV_POPULAR_PAGE:variant_3
	// ?new_remove_preferred_experiment=EXP_JWTV_POPULAR_PAGE
	EXP_JWTV_POPULAR_PAGE: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1', VARIANT_2: 'variant_2', VARIANT_3: 'variant_3' },
		routes: [],
		tabs: ['popular'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),
	// ?new_preferred_variant=EXP_PRIME_SQTV:control
	// ?new_preferred_variant=EXP_PRIME_SQTV:variant_1
	// ?new_remove_preferred_experiment=EXP_PRIME_SQTV
	EXP_PRIME_SQTV: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'prsqtv',
	}),
	// ?new_preferred_variant=EXP_JWTV_AVOD_CINEMATIC_PAGES_2:control
	// ?new_preferred_variant=EXP_JWTV_AVOD_CINEMATIC_PAGES_2:variant_1
	// ?new_preferred_variant=EXP_JWTV_AVOD_CINEMATIC_PAGES_2:variant_2
	// ?new_remove_preferred_experiment=EXP_JWTV_AVOD_CINEMATIC_PAGES_2
	EXP_JWTV_AVOD_CINEMATIC_PAGES_2: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1', VARIANT_2: 'variant_2' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),
	// ?new_preferred_variant=EXP_UK_HOME_2:control
	// ?new_preferred_variant=EXP_UK_HOME_2:variant_1
	// ?new_preferred_variant=EXP_UK_HOME_2:variant_2
	// ?new_remove_preferred_experiment=EXP_UK_HOME_2
	EXP_UK_HOME_2: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1', VARIANT_2: 'variant_2' },
		routes: [],
		tabs: ['home'],
		userTypes: ['LOGGED_OUT'],
		type: 'regular',
	}),
	// ?new_preferred_variant=EXP_GRID_SWIPER:control
	// ?new_preferred_variant=EXP_GRID_SWIPER:variant_1
	// ?new_preferred_variant=EXP_GRID_SWIPER:variant_2
	// ?new_remove_preferred_experiment=EXP_GRID_SWIPER
	EXP_GRID_SWIPER: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1', VARIANT_2: 'variant_2' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'gridsw',
	}),
	// ?new_preferred_variant=EXP_ATV_LANDING_PAGE:control
	// ?new_preferred_variant=EXP_ATV_LANDING_PAGE:variant_1
	// ?new_remove_preferred_experiment=EXP_ATV_LANDING_PAGE
	EXP_ATV_LANDING_PAGE: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'atvlpg',
	}),

	// ?new_preferred_variant=EXP_GRID_REDESIGN_CLICK:control
	// ?new_preferred_variant=EXP_GRID_REDESIGN_CLICK:variant_1
	// ?new_preferred_variant=EXP_GRID_REDESIGN_CLICK:variant_2
	// ?new_preferred_variant=EXP_GRID_REDESIGN_CLICK:variant_3
	// ?new_preferred_variant=EXP_GRID_REDESIGN_CLICK:variant_4
	// ?new_remove_preferred_experiment=EXP_GRID_REDESIGN_CLICK
	EXP_GRID_REDESIGN_CLICK: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'grclick',
	}),
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:control
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:variant_1
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:variant_2
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:variant_3
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:variant_4
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:variant_5
	// ?new_remove_preferred_experiment=EXP_GRID_REDESIGN_MORE_INFO
	EXP_GRID_REDESIGN_MORE_INFO: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
			VARIANT_5: 'variant_5',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'grinfo',
	}),
	// ?new_preferred_variant=EXP_PRE_ROLL_GRID:control
	// ?new_preferred_variant=EXP_PRE_ROLL_GRID:variant_1
	// ?new_preferred_variant=EXP_PRE_ROLL_GRID:variant_2
	// ?new_preferred_variant=EXP_PRE_ROLL_GRID:variant_3
	// ?new_remove_preferred_experiment=EXP_PRE_ROLL_GRID
	EXP_PRE_ROLL_GRID: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'preroll',
	}),
	// ?new_preferred_variant=EXP_SOFTER_FREE_TRIAL_LIST_BB:control
	// ?new_preferred_variant=EXP_SOFTER_FREE_TRIAL_LIST_BB:variant_1
	// ?new_preferred_variant=EXP_SOFTER_FREE_TRIAL_LIST_BB:variant_2
	// ?new_preferred_variant=EXP_SOFTER_FREE_TRIAL_LIST_BB:variant_3
	// ?new_preferred_variant=EXP_SOFTER_FREE_TRIAL_LIST_BB:variant_4
	// ?new_preferred_variant=EXP_SOFTER_FREE_TRIAL_LIST_BB:variant_5
	// ?new_preferred_variant=EXP_SOFTER_FREE_TRIAL_LIST_BB:variant_6
	// ?new_remove_preferred_experiment=EXP_SOFTER_FREE_TRIAL_LIST_BB
	EXP_SOFTER_FREE_TRIAL_LIST_BB: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
			VARIANT_5: 'variant_5',
			VARIANT_6: 'variant_6',
		},
		routes: ['app.detail.movies'],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'softl',
	}),
} satisfies ExperimentConfig;
